import React from "react";
import { Card, CardActions, CardContent, Typography } from "@mui/material";
import { Pencil, Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";

import { ButtonIconOnly } from "src/UI/ButtonIconOnly";
import { CorporateBrandAssetDto } from "../types";

interface ModelCardProps {
  model: CorporateBrandAssetDto;
  onEdit: (model: CorporateBrandAssetDto) => void;
  onDelete: (model: CorporateBrandAssetDto) => void;
}

const ModelCard: React.FC<ModelCardProps> = ({ model, onEdit, onDelete }) => {
  const { t } = useTranslation(["corporate-brand-asset"]);
  return (
    <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography variant="h6" sx={{ mb: 1 }}>
          {model.name}
        </Typography>
      </CardContent>
      <CardActions sx={{ justifyContent: "flex-end", gap: 1 }}>
        <ButtonIconOnly
          size="sm"
          tooltip={String(t("actions.edit"))}
          aria-label={String(t("actions.edit") || "edit")}
          onClick={() => onEdit(model)}
          iconOnly={<Pencil size={16} />}
        />
        <ButtonIconOnly
          size="sm"
          tooltip={String(t("actions.delete"))}
          aria-label={String(t("actions.delete") || "delete")}
          onClick={() => onDelete(model)}
          iconOnly={<Trash2 size={16} />}
          sx={{
            color: "error.main",
            borderColor: "error.main",
            "&:active, &:focus-visible, &.Mui-focusVisible": {
              borderColor: "error.main",
            },
          }}
        />
      </CardActions>
    </Card>
  );
};

export default ModelCard;
